<template>
  <div id="app">
    <!-- PORT-001 : l'agent de sécurité n'a ni barre latérale, ni actions rapides, ni file d'attente. -->
    <div v-if="mode_portail && this.$router.history.current.name !='login'" class="portail-shell">
      <header class="portail-shell__barre">
        <img class="portail-shell__logo" src="./assets/images/cca-blogo.svg" alt="LOGO CLINICAA">
        <span class="portail-shell__espace">Contrôle des sorties</span>
        <span class="portail-shell__separateur" aria-hidden="true"></span>
        <router-link v-if="sur_guide" :to="route_portail" class="portail-shell__lien">
          <i class="fas fa-arrow-left" aria-hidden="true"></i> Contrôle des sorties
        </router-link>
        <router-link v-else :to="route_guide_portail" class="portail-shell__lien">
          <i class="fa fa-question-circle" aria-hidden="true"></i> Guide
        </router-link>
        <details class="portail-shell__profil" ref="profil_portail">
          <summary class="portail-shell__profil-bouton" aria-label="Profil et changement de rôle">
            <img class="portail-shell__avatar" src="./assets/avatar.png" alt="">
            <span class="portail-shell__identite">
              <strong :title="nom_agent">{{ nom_agent }}</strong>
              <small>{{ libelle_role_actif }}</small>
            </span>
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </summary>
          <div class="portail-shell__menu">
            <p class="portail-shell__menu-titre">Changer de rôle</p>
            <div class="portail-shell__role-list">
            <span class="portail-shell__role-actif"><i class="fa fa-check" aria-hidden="true"></i> {{ libelle_role_actif }}</span>
            <button v-for="role in autres_roles_caisse" :key="'role-' + role.id" type="button"
              class="portail-shell__role-option" :disabled="changement_role" @click="changerRolePortail(role)">
              {{ role.libelle }}
            </button>
            <p v-if="!autres_roles_caisse.length" class="portail-shell__role-vide">Aucun autre rôle attribué</p>
            </div>
            <div class="portail-shell__menu-footer">
              <router-link to="/parametres/profil" @click.native="fermerProfilPortail"><i class="fa fa-user" aria-hidden="true"></i> Mon profil</router-link>
              <button type="button" @click="deconnecterPortail"><i class="fas fa-sign-out-alt" aria-hidden="true"></i> Se déconnecter</button>
            </div>
          </div>
        </details>
        <p v-if="message_role" class="portail-shell__erreur" role="alert">{{ message_role }}</p>
      </header>
      <main class="portail-shell__contenu">
        <router-view />
      </main>
    </div>
    <div v-else-if="this.$router.history.current.name !='login'" class="wrapper" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <Sidebar />
      <div class="content">
        <Navbar :sidebar-collapsed="sidebarCollapsed" @toggle-sidebar="toggleDesktopSidebar" />
        <DropdownQuickAction/>
        <div class="content-body p-4 scroll-bar">
          <router-view />
        </div>
      </div>
    </div>
     <div v-else>
          <router-view/>
     </div>

  </div>
</template>
<script>
import Sidebar from "@/components/sidebar";
import Navbar from "@/components/navbar";
import DropdownQuickAction from '@/components/dropdown-quick-actions';
import {
  ROUTE_GUIDE, ROUTE_GUIDE_PORTAIL, ROUTE_PORTAIL_SORTIES, autresRolesPortail, espaceRole, estAgentSecurite, fermerSession, routeApresChangementRole
} from '@/utils/portail-sorties';


export default {
  name: "Home",

  data() {
    return {
      value: null,
      sidebarCollapsed: false,
      route_portail: ROUTE_PORTAIL_SORTIES,
      route_guide_portail: ROUTE_GUIDE_PORTAIL,
      changement_role: false,
      message_role: '',

    };
  },
  components: {
    Sidebar,
    Navbar,
    DropdownQuickAction
  },
  computed: {
    mode_portail() {
      const store = this.$store
      return !!store && !!store.getters && estAgentSecurite(store.getters['authInfo'], store.getters['activeRole'])
    },
    nom_agent() {
      const auth_info = this.$store && this.$store.getters ? this.$store.getters['authInfo'] : null
      return auth_info && auth_info.user && auth_info.user.name ? auth_info.user.name : 'Agent de sécurité'
    },
    libelle_role_actif() {
      const getters = this.$store && this.$store.getters
      const actif = getters && getters['activeRole']
      const roles = getters && getters['authInfo'] && getters['authInfo'].user && getters['authInfo'].user.roles
      const role = Array.isArray(roles) && actif ? roles.find(item => item.nom === actif.nom) : null
      return (role && role.description) || (actif && actif.description) || 'Agent de sécurité'
    },
    autres_roles_caisse() {
      const store = this.$store
      return store && store.getters ? autresRolesPortail(store.getters['authInfo']) : []
    },
    sur_guide() {
      return !!this.$route && this.$route.path === ROUTE_GUIDE
    }
  },
  methods: {
    toggleDesktopSidebar() { this.sidebarCollapsed = !this.sidebarCollapsed },
    fermerProfilPortail() {
      if (this.$refs && this.$refs.profil_portail) this.$refs.profil_portail.open = false
    },
    // Le rôle actif enregistré côté serveur change : le routeur ne confine plus l'utilisateur.
    changerRolePortail(role) {
      if (!role || !espaceRole(role.nom) || this.changement_role) return
      const espace = espaceRole(role.nom)
      const destination = espace === 'clinique' ? this.base_url_clinique : espace === 'stock' && this.base_url_stock ? String(this.base_url_stock).replace(/\/+$/, '') + (role.nom === 'ROLE_RESPONSABLE_LOGISTIQUE' ? '/espaces' : '') : espace === 'rh' ? this.base_url_rh : ''
      if (espace !== 'caisse' && !destination) {
        this.message_role = 'L’adresse de cet espace n’est pas configurée.'
        return
      }
      const auth_info = this.$store.getters['authInfo']
      const user_id = auth_info && auth_info.user ? auth_info.user.id : 0
      this.changement_role = true
      this.message_role = ''
      return this.$store.dispatch('switchRole', { userId: user_id, roleId: role.id }).then(() => {
        this.changement_role = false
        if (this.$refs && this.$refs.profil_portail) this.$refs.profil_portail.open = false
        if (destination) {
          window.location.assign(destination)
          return
        }
        const navigation = this.$router.push({ path: routeApresChangementRole(role.nom) })
        if (navigation && typeof navigation.catch === 'function') navigation.catch(() => {})
      }, () => {
        this.changement_role = false
        this.message_role = 'Changement de rôle impossible. Vérifiez la connexion puis réessayez.'
      })
    },
    // Poste partagé : on quitte d'abord l'écran, puis on efface la session (évite un rendu sans utilisateur).
    deconnecterPortail() {
      const store = this.$store
      const stockage = typeof localStorage !== 'undefined' ? localStorage : null
      const fermer = () => fermerSession(store, stockage, true)
      const navigation = this.$router.push({ path: '/login' })
      if (navigation && typeof navigation.then === 'function') navigation.then(fermer, fermer)
      else fermer()
    }
  },
};
</script>
<style>
@media (min-width: 1201px) {
  .wrapper.sidebar-collapsed > #sdbr { transform: translateX(-100%); visibility: hidden; }
  .wrapper.sidebar-collapsed > .content { padding-left: 0; }
  .wrapper.sidebar-collapsed > .content .navbar { left: 0; }
  .wrapper.sidebar-collapsed > .content .dropdown-quick-actions .bon-catalogue-fond { left: 0; }
  .wrapper.sidebar-collapsed > .content .dropdown-quick-actions .bon-ordre-fond { left: 0; }
  .wrapper.sidebar-collapsed .section-body {
    left: 44px;
    right: 44px;
  }
  .wrapper.sidebar-collapsed .dashboard-finance-body {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  #sdbr.sidebar { transition: none; }
}
/* PORT-001 : coque minimale du contrôle des sorties (téléphone, tablette, poste). */
.portail-shell { min-height: 100vh; background: #f5f8fd; }
.portail-shell__barre { position: sticky; top: 0; z-index: 10; display: flex; flex-wrap: wrap; align-items: center; gap: 8px 14px; min-height: 68px; padding: 8px 24px; background: #fff; border-bottom: 1px solid #e2e9f4; box-shadow: 0 2px 12px rgba(44, 63, 97, .04); }
.portail-shell__logo { height: 32px; flex: 0 0 auto; }
.portail-shell__espace { color: var(--ui-text, #2C3F61); font-size: 16px; font-weight: 600; white-space: nowrap; }
.portail-shell__separateur { flex: 1 1 auto; }
.portail-shell__lien { display: inline-flex; flex: 0 0 auto; align-items: center; gap: 6px; min-height: 44px; padding: 0 12px; border-radius: 8px; color: #0075ff; font-size: 16px; font-weight: 600; text-decoration: none; }
.portail-shell__lien:hover { background: #e5f1ff; text-decoration: none; }
.portail-shell__deconnexion { flex: 0 0 auto; min-height: 44px; padding: 0 12px; border: 0; border-radius: 8px; background: transparent; color: var(--ui-text-secondary, #66758f); font-size: 14px; font-weight: 600; cursor: pointer; }
.portail-shell__deconnexion:hover { background: #fff2f2; color: #a63835; }
.portail-shell__profil { position: relative; flex: 0 0 auto; min-width: 205px; font-family: 'Sen', Arial, sans-serif; }
.portail-shell__profil-bouton { display: flex; align-items: center; gap: 10px; min-height: 48px; padding: 5px 10px; border-radius: 10px; background: #f1f6fd; color: var(--ui-text, #2C3F61); cursor: pointer; list-style: none; }
.portail-shell__profil-bouton::-webkit-details-marker { display: none; }
.portail-shell__profil-bouton:hover, .portail-shell__profil[open] .portail-shell__profil-bouton { background: #e8f0fc; }
.portail-shell__avatar { width: 34px; height: 34px; border-radius: 50%; object-fit: cover; }
.portail-shell__identite { display: flex; flex: 1; flex-direction: column; min-width: 0; line-height: 1.3; }
.portail-shell__identite strong { overflow: hidden; font-size: 13px; text-overflow: ellipsis; white-space: nowrap; }
.portail-shell__identite small { color: var(--ui-text-secondary, #8390a8); font-size: 11px; }
.portail-shell__menu { position: absolute; top: calc(100% + 8px); right: 0; z-index: 20; display: flex; flex-direction: column; width: 280px; max-width: calc(100vw - 24px); max-height: 70vh; padding: 8px; border: 1px solid #d9e2ef; border-radius: 12px; background: #fff; box-shadow: 0 14px 32px rgba(44, 63, 97, .15); }
.portail-shell__role-list { min-height: 0; overflow-y: auto; }
.portail-shell__menu-titre { margin: 4px 8px 8px; color: var(--ui-text-secondary, #8390a8); font-size: 12px; font-weight: 600; }
.portail-shell__role-actif, .portail-shell__role-option, .portail-shell__role-vide { display: flex; align-items: center; gap: 8px; width: 100%; min-height: 44px; padding: 8px 12px; border: 0; border-radius: 8px; text-align: left; font-size: 14px; }
.portail-shell__role-actif { background: #edf4ff; color: #3b73f5; font-weight: 600; }
.portail-shell__role-option { background: #fff; color: var(--ui-text, #2C3F61); cursor: pointer; }
.portail-shell__role-option:hover { background: #f1f6fd; }
.portail-shell__role-option:disabled { opacity: .5; cursor: wait; }
.portail-shell__role-vide { color: var(--ui-text-secondary, #8390a8); }
.portail-shell__menu-footer { flex: 0 0 auto; margin-top: 8px; padding-top: 8px; border-top: 1px solid #e1e8f2; }
.portail-shell__menu-footer a, .portail-shell__menu-footer button { display: flex; align-items: center; gap: 10px; width: 100%; min-height: 44px; padding: 8px 12px; border: 0; border-radius: 8px; background: #fff; color: var(--ui-text, #2C3F61); text-align: left; font-size: 14px; text-decoration: none; cursor: pointer; }
.portail-shell__menu-footer a:hover, .portail-shell__menu-footer button:hover { background: #f1f6fd; text-decoration: none; }
.portail-shell__menu-footer i { width: 18px; color: var(--ui-text-secondary, #7485a4); }
.portail-shell__menu-footer a:focus-visible, .portail-shell__menu-footer button:focus-visible { outline: 2px solid #0075ff; outline-offset: 2px; }
.portail-shell__deconnexion:focus-visible, .portail-shell__lien:focus-visible, .portail-shell__profil-bouton:focus-visible, .portail-shell__role-option:focus-visible { outline: 2px solid #0075ff; outline-offset: 2px; }
.portail-shell__erreur { flex: 1 0 100%; margin: 0; color: #a63835; font-size: 16px; }
.portail-shell__contenu { padding: 16px; }
@media (max-width: 575px) {
  .portail-shell__barre { padding: 8px 12px; }
  .portail-shell__logo { height: 27px; }
  .portail-shell__espace { display: none; }
  .portail-shell__deconnexion { font-size: 0; }
  .portail-shell__deconnexion i { font-size: 17px; }
  .portail-shell__profil { min-width: 165px; }
  .portail-shell__contenu { padding: 12px; }
}
</style>

